










import CoRightOfWithdrawalForm from '../../components/Organisms/co-right-of-withdrawal-form/coRightOfWithdrawalForm.vue';

export default {
    name: 'RightOfWithdrawal',
    components: {
        CoRightOfWithdrawalForm,
    },
};
